export default __webpack_public_path__ + "static/media/users.0b06d384.svg";